import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface AppStore {
  /** Epoch time after which to show the match auto banner */
  autoBannerDismissedUntil: number;
  /** Set the epoch time after which to show the matcha auto banner */
  setAutoBannerDismissedUntil: (date: number) => void;
  /** Whether the user has dismissed the limit order fill info */
  dismissedLimitOrderFillInfo: boolean;
  /** Set whether the user has dismissed the limit order fill info */
  setDismissedLimitOrderFillInfo: (dismissed: boolean) => void;
  /** Whether the chart is expanded in token profile */
  isChartExpanded: boolean;
  /** Set whether the chart is expanded */
  setIsChartExpanded: (expanded: boolean) => void;
}

export const useAppStore = createWithEqualityFn<AppStore>()(
  persist(
    (set) => ({
      autoBannerDismissedUntil: new Date().getTime(),
      dismissedLimitOrderFillInfo: false,
      isChartExpanded: false,
      setAutoBannerDismissedUntil: (autoBannerDismissedUntil: number) =>
        set({ autoBannerDismissedUntil }),
      setDismissedLimitOrderFillInfo: (dismissedLimitOrderFillInfo: boolean) =>
        set({ dismissedLimitOrderFillInfo }),
      setIsChartExpanded: (isChartExpanded: boolean) => set({ isChartExpanded }),
    }),
    {
      name: 'app-store',
      partialize: (state) => ({
        autoBannerDismissedUntil: state.autoBannerDismissedUntil,
        dismissedLimitOrderFillInfo: state.dismissedLimitOrderFillInfo,
        isChartExpanded: state.isChartExpanded,
      }),
    },
  ),
  shallow,
);

export const dismissedLimitOrderFillInfoSelectors = (state: AppStore) => ({
  dismissedLimitOrderFillInfo: state.dismissedLimitOrderFillInfo,
  setDismissedLimitOrderFillInfo: state.setDismissedLimitOrderFillInfo,
});
export const autoBannerSelectors = ({
  autoBannerDismissedUntil,
  setAutoBannerDismissedUntil,
}: AppStore) => ({
  autoBannerDismissedUntil,
  setAutoBannerDismissedUntil,
});
